import { render } from "./TemplateProfile.vue?vue&type=template&id=beeacf34&ts=true"
import script from "./TemplateProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateProfile.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/templates/components/TemplateProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "beeacf34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('beeacf34', __exports__)) {
    api.reload('beeacf34', __exports__)
  }
  
  module.hot.accept("./TemplateProfile.vue?vue&type=template&id=beeacf34&ts=true", () => {
    api.rerender('beeacf34', render)
  })

}


export default __exports__